import React, { useContext } from 'react';
import classNames from 'classnames';
import ShareableLinkDataContext from 'router/subrouters/ShareableLink/providers/ShareableLinkData/ShareableLinkData.context';
import { Link } from 'react-router-dom';
import { BUSINESS_ROUTE } from 'data/global';
import { ReactComponent as ResolveLogoSvg } from 'icons/Resolve.svg';
import BrandingLogo from 'components/BrandingLogo';

import './ShareableLinkMobileNavigation.styles.scss';

type ShareableLinkMobileNavigationProps = {
  className?: string;
};

const ShareableLinkMobileNavigation: React.FC<
  ShareableLinkMobileNavigationProps
> = (props) => {
  const { className } = props;

  const {
    shareableLink: { dataRoom },
  } = useContext(ShareableLinkDataContext);

  const { logo, mobileLogo } = dataRoom || {};

  const classes = classNames('shareable-link-mobile-navigation', className);

  return (
    <div className={classes}>
      {!logo ? (
        <Link to={BUSINESS_ROUTE} aria-label="Resolve logo">
          <ResolveLogoSvg />
        </Link>
      ) : (
        <BrandingLogo brandingLogos={{ logo, mobileLogo }} height={40} />
      )}
    </div>
  );
};

export default ShareableLinkMobileNavigation;
